import { forEach } from "lodash";
import { MenuItem } from "./menu-item";
export class MenuCategory {
    constructor(id, name, description, sortOrder, menuItems) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.sortOrder = sortOrder;
        this.menuItems = menuItems;
        this.menuItems = menuItems.filter((item) => !((!item?.isAvailable && item?.isHidden) ||
            // app specific item
            !!item.isAppOnly));
    }
    static fromDynamic(data) {
        // parse menu items for this category, separate by availablility
        const availableItems = [];
        const unavailableItems = [];
        forEach(data["menu_items"] ?? [], (menuItemJson) => {
            const parsedMenuItem = MenuItem.fromDynamic(menuItemJson);
            if (parsedMenuItem?.isAvailable) {
                availableItems.push(parsedMenuItem);
            }
            else {
                unavailableItems.push(parsedMenuItem);
            }
        });
        // sort the items by availability
        availableItems.sort((a, b) => a.sortOrder - b.sortOrder);
        unavailableItems.sort((a, b) => a.sortOrder - b.sortOrder);
        const name = `${data["name"]}`.endsWith(".")
            ? `${data["name"]}`.slice(0, `${data["name"]}`.length - 1)
            : `${data["name"]}`;
        return new MenuCategory(data["id"], name, data["description"], data["sort_order"], availableItems.concat(unavailableItems) // show unavailable last
        );
    }
}
//# sourceMappingURL=menu-category.js.map